import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Images, PermissionList, useBaseModal } from 'utils';
import { EditWithIcon, SimpleTabs } from 'components';
import { Baseline } from './baseline';
import { MasteryBox } from './masteryBox';
import { eventOnModel, Events } from '../../../../../clinicalFragments';

const goalDetailsLabels = [
    { label: 'Baseline' },
    { label: 'Progress Rules' },
    { label: 'Events' },
];

export const BaselineDetails = ({ target }) => {
    const [tab, setTab] = useState('Baseline');
    const { closeBase } = useBaseModal();
    const goalById = useSelector((state) => state.goals.goalById);

    const tabsContent = [
        {
            tabComponent: <Baseline target={target} />,
            tab: 'Baseline',
        },
        {
            tabComponent: <MasteryBox target={target} />,
            tab: 'Progress Rules',
        },
        {
            tabComponent: (
                <Events
                    model={{ goalId: goalById?.id, resource: target?.id, onModel: eventOnModel.Target }}
                    permissions={[PermissionList.GOAL_CREATE?.code]}
                />
            ),
            tab: 'Events',
        },
    ];

    return (
        <div style={{ width: 1400, maxWidth: '100%' }}>
            <div className="flex-align-center" style={{ gap: 8 }}>
                <EditWithIcon icon={Images.backArrow} type={'button'} handleClick={closeBase} />
                <p className="modal-header-title">{target?.name}</p>
            </div>
            <SimpleTabs tab={tab} getTab={setTab} defaultTab={tab} tabsLabels={goalDetailsLabels} tabsContent={tabsContent} />
        </div>
    );
};
